import React, { Fragment } from 'react';
import AgentList from '../agentlist/AgentList';
import styles from './alternativeResults.less';
var AlternativeResults = function AlternativeResults(_ref) {
  var term = _ref.term,
    geoPathUri = _ref.geoPathUri;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.emptyListHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.emptyListImgBlock
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    src: "https://www.static-immobilienscout24.de/statpic/agent-search-web/b32a23b7f586474dc12a47c015ca471e_IS24_EmptyBox.png",
    alt: "keine Ergebnisse",
    className: "inline-block"
  }), /*#__PURE__*/React.createElement("p", {
    className: "inline-block absolute-reference margin-left-m font-hint ".concat(styles.emptyListMessage)
  }, "Leider haben wir keine Ergebnisse f\xFCr Ihre Suche.")), /*#__PURE__*/React.createElement("h3", {
    className: "font-heading-small-regular margin-bottom-none",
    "data-testid": "empty-list-headline"
  }, "Alternative Immobilienmakler in ", term)), /*#__PURE__*/React.createElement(AgentList, null), /*#__PURE__*/React.createElement("div", {
    className: "margin-bottom-xxl"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/anbieter/immobilienmakler".concat(geoPathUri),
    className: "link-text",
    "aria-label": "Alle alternativen Immobilienmakler",
    "data-testid": "nearby-search-link"
  }, /*#__PURE__*/React.createElement("span", {
    className: "is24-icon-chevron-right",
    "aria-hidden": true
  }), " Alle alternativen Immobilienmakler")));
};
export default AlternativeResults;